import Image from 'app/Components/Shared/Image/image';
import React,  {useState} from 'react';
import {isMobile} from 'react-device-detect';
import BtnWhiteBlackBorderBigSize from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Icons} from './Icons';
import {Tags} from './Tags';
import {AdditionalArticles} from './AdditionalArticles';

import {
  getDateFromISO,
  getFullPath,
  extractIconElements,
  extractTagsElements,
  extractAdditionalArticlesElements,
  iframeScreenAdjustment,
} from './utilities';

export const ArticlePagesBlockMain = (props) => {
  const content = {
    mainHeading: props.contentData?.mainHeading?.value,
    secondaryHeading: props.contentData?.secondaryHeading?.value,
    articleCreator: props.contentData?.articleCreator?.value,
    articleDate: getDateFromISO(props.contentData?.articleDate?.value),
    iconsList: extractIconElements(props.contentData?.socialNetworksIconsDataList?.expandedValue),
    tagsList: extractTagsElements(props.contentData?.tagsDataList?.expandedValue),
    backgroundImg: isMobile
      ? getFullPath(props.contentData?.backgroundImageMobile?.value?.url)
      : getFullPath(props.contentData?.backgroundImageDesktop?.value?.url),
    underImageText: props.contentData?.underImageText?.value,
    articleContent: isMobile
      ? iframeScreenAdjustment(props.contentData?.articleContent?.value, 'width="339px" height="184px"')
      : iframeScreenAdjustment(props.contentData?.articleContent?.value, 'width="742px" height="300px"'),
    showAdditionalArticles: props.contentData?.showAdditionalArticles?.value,
    additionalArticles: extractAdditionalArticlesElements(props.contentData?.additionalArticles?.expandedValue),
  };

  const showAdditionalArticles=content.showAdditionalArticles && content.additionalArticles;
  const [desktopArticles, setDesktopArticles] = useState(content.additionalArticles?.slice(0, 3) || []);
  const [additionalBtnText, setBtnText] = useState('כתבות נוספות');
  const [showAdditional, setAdditionalDisplay] = useState(false);

  const handleMoreArticlesClick = () => {
    if (showAdditional) {
      setDesktopArticles([...content.additionalArticles]);
      setBtnText('חזרה לכתבות נבחרות');
    } else {
      setDesktopArticles([...content.additionalArticles.slice(0, 3)]);
      setBtnText('כתבות נוספות');
    }
  };

  return (
    <div className={isMobile ? 'article-pages-block-mobile' : 'article-pages-block'}>
      <div className='article-pages-header'>
        <div className='upper-page-container'>
          <div className='main-heading' dangerouslySetInnerHTML={{__html: content.mainHeading}} />
          {!isMobile && <div className='secondary-heading' dangerouslySetInnerHTML={{__html: content.secondaryHeading}} />}
          <div className='icons-date-author-container'>
           <div className='date-container'>
              <p className='author-name'>{content.articleCreator}</p>
              {content.articleCreator&&content.articleDate&&<div className='vertical-line'></div>}
              <p className='article-date'>{content.articleDate}</p>
            </div>
            {!isMobile && content.iconsList?.length>0 && (
              <div className='icons-container'>
                <Icons iconList={content.iconsList?.reverse()} />
              </div>
            )}
          </div>
          {!isMobile && content.tagsList?.length>0 && (
            <div className='tags-container'>
              <Tags tagList={content.tagsList?.reverse()} context={props.context} />
            </div>
          )}
        </div>

        <div className='page-pic-container'>
          <Image className='page-pic' src={content.backgroundImg} />
          <div className='under-image-text-container'>
            <div className='under-image-text'>{content.underImageText}</div>
            {isMobile &&content.tagsList?.length>0 && (
              <div className='tags-container'>
                <Tags tagList={content.tagsList?.reverse()} context={props.context} />
              </div>
            )}
            {isMobile && content.iconsList?.length>0 &&(
              <div className='icons-container'>
                <Icons iconList={content.iconsList?.reverse()} />
              </div>
            )}
          </div>
        </div>

        <div className='under-page-container'>
          <div className='article-content-container'>
            <p className='article-content' dangerouslySetInnerHTML={{__html: content.articleContent}} />
          </div>
          {content.tagsList?.length>0 &&<div className='tags-container'>
            <Tags tagList={content.tagsList?.reverse()} context={props.context} />
          </div>}
        </div>
      </div>
      {showAdditionalArticles && content.additionalArticles?.length>0 &&(
        <div className='additional-articles-section-container'>
          <div className='horizontal-line'></div>
          <div className='heading'>כתבות נוספות</div>
          <div className={desktopArticles.length>1?'additional-articles-container':'additional-articles-container single-element'}>
            {!isMobile ? (
              desktopArticles?.reverse().map((element, i) => {
                return <AdditionalArticles element={element} key={i} context={props.context} />;
              })
            ) : (
              <Swiper
                spaceBetween={5}
                centeredSlides
                slidesPerView={ desktopArticles.length>1 ? 1.2 : 1}
                pagination={{clickable: true}}
                className='d-block d-md-none'
                style={{paddingTop: '10px', paddingBottom: '10px'}}>
                {content.additionalArticles?.map((element, i) => (
                  <SwiperSlide key={i}>
                    <AdditionalArticles element={element} key={i} context={props.context} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
          {!isMobile && content.additionalArticles?.length > 3 && (
            <BtnWhiteBlackBorderBigSize
              onclick={() => {
                setAdditionalDisplay(!showAdditional);
                handleMoreArticlesClick();
              }}
              text={additionalBtnText}
            />
          )}
        </div>
      )}
    </div>
  );
};
